import { useCallback } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button/Button'

import { getFormedEltTranslation } from '../../../../helpers/getFormedEltTranslation'
import { Title } from '../../title/Title'

import styles from './RefreshFormConfirmDialogContent.module.scss'

interface IProps {
  onAgree: () => void
  closeDialog: () => void
}

export const RefreshFormConfirmDialogContent = ({ onAgree, closeDialog }: IProps) => {
  const onAgreeClick = useCallback(() => {
    closeDialog()
    onAgree()
  }, [onAgree, closeDialog])

  return (
    <div className={styles.root}>
      <Title align={'center'} text={getFormedEltTranslation('refresh-dialog')} />
      <Translation text={getFormedEltTranslation('refresh-text')} />
      <div className={styles.btnWrapper}>
        <Button onClick={onAgreeClick}>
          <Translation text={getFormedEltTranslation('refresh-agree')} />
        </Button>
      </div>
    </div>
  )
}
